import type { SelectOption } from '@didaskill/types/web';

/**
 * Returns a plain-text label for a select option.
 * Prefers `stringifiedLabel`, then a string `label`, then the option value.
 * @param option Selected option.
 * @returns Displayable label.
 */
export function getSelectOptionLabel(option: SelectOption): string {
  if (option.stringifiedLabel) {
    return option.stringifiedLabel;
  }

  if (typeof option.label === 'string') {
    return option.label;
  }

  if (option.value === undefined || option.value === null) {
    return '';
  }

  return String(option.value);
}
